import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledSeparatorLine = styled.div`
  width: 100%;
  height: 0.5px;
  background-color: ${colors.lightBlueGray};
  margin: 30px 0 25px;
`;
